// extracted by mini-css-extract-plugin
export default {"readNum":"index_readNum_DmG-y"};